import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="payment-result" data-testid="payment-cancel-page">
      <div className="pay-card">
        <span className="pay-ic warn"><XCircle size={40} /></span>
        <h1>Checkout cancelled</h1>
        <p>No charge was made. Your plan is unchanged — upgrade whenever you're ready.</p>
        <button className="primary-btn" onClick={() => nav("/plans")} data-testid="cancel-back-to-plans">Back to plans</button>
      </div>
    </div>
  );
}
